import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { projects } from '../data/projects';
import './caseStudy.css';

export default function CaseStudy() {
  const { slug } = useParams();
  const project = projects.find((item) => item.id === slug);
  if (!project) return <section className="section-shell interior-page"><h1>Project not found</h1><Link className="pill-link" to="/projects">Explore all projects</Link></section>;
  const next = projects[(projects.indexOf(project) + 1) % projects.length];
  return <article className={`case-study interior-page case-study--${project.theme}`}>
    <header className="case-study__intro section-shell" data-reveal>
      <Link className="case-study__back" to="/projects">←︎ All projects</Link>
      <span className="eyebrow">SELECTED WORK / {project.category.toUpperCase()}</span>
      <h1 tabIndex="-1">{project.title}</h1><p>{project.description}</p>
      <div className="case-study__actions">{project.links.map((link) => <a className="pill-link pill-link--light" href={link.href} target="_blank" rel="noreferrer" key={link.href}>{link.label} ↗︎</a>)}</div>
    </header>
    <section className="case-study__gallery section-shell" aria-label={`${project.title} case study images`}>
      {project.caseStudyImages?.map((image, index) => {
        const imageSrc = typeof image === 'string' ? image : image.src;
        const presentation = typeof image === 'string' ? 'scene' : image.presentation;
        return <figure className={`case-study__image case-study__image--${presentation}`} data-reveal key={imageSrc}>
        <img src={imageSrc} alt={`${project.title} case study${project.caseStudyImages.length > 1 ? `, image ${index + 1}` : ''}`} loading={index === 0 ? 'eager' : 'lazy'} />
        {project.caseStudyImages.length === 1 && <figcaption>{project.title} / {project.category}</figcaption>}
      </figure>;
      })}
    </section>
    <nav className="case-study__next section-shell" aria-label="Next case study" data-reveal><span className="eyebrow">KEEP EXPLORING</span><Link to={next.caseStudy}>{next.title}<span aria-hidden="true">↗︎</span></Link></nav>
  </article>;
}
